import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Field, reduxForm, formValueSelector, FieldArray } from 'redux-form';
import submit from './submit';
import validate from './validate';
import { connect } from 'react-redux';

// Style
import cx from 'classnames';
import { Button } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';

// Translation
import { FormattedMessage, injectIntl } from 'react-intl';
import FieldArrayComponent from '../../CommonFields/FieldArrayComponent';
import { formatLocaleData } from '../../../helpers/formatLocale';

import cs from '../../../components/commonStyle.css';
import s from './FooterBlockForm.css';
import messages from '../../../locale/jsonMessages';
class FooterBlockForm extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    title: PropTypes.string.isRequired,
  };



  render() {

    const { error, handleSubmit, submitting, dispatch, initialValues, title, selectedLanguage } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div className='siteAdminCenterContainer siteAdminCenterContainerBox'>
        <h1 className='siteAdminHeading'><FormattedMessage  {...messages.footerBlockLabel} /></h1>
        <form onSubmit={handleSubmit(submit)}>
          {error && <strong>{formatMessage(error)}</strong>}
          <div className="oneColumnGrid">
            <FieldArray
              name="dynamicFooterBlock"
              component={FieldArrayComponent}
              activesFields={['language', 'title1', 'content1', 'title2', 'content2', 'title3', 'content3']}
              filedName={"dynamicFooterBlock"}
              selectedLanguage={selectedLanguage}
            />
          </div>
          <div className={cx(cs.spaceTop4, 'singleBtnFlexEnd')}>
            <Button className={cx(cs.btnPrimary)} type="submit" disabled={submitting}>
              <FormattedMessage  {...messages.save} />
            </Button>
          </div>
        </form>
      </div>
    );
  }

}

FooterBlockForm = reduxForm({
  form: 'FooterBlockForm', // a unique name for this form
  validate
})(FooterBlockForm);

const selector = formValueSelector('FooterBlockForm');

const mapState = (state) => ({
  selectedLanguage: selector(state, 'dynamicFooterBlock'),
  activeLanguageCodes: state.runtime.isActiveLanguages.map(item => formatLocaleData(item))
});

export default injectIntl(withStyles(cs, s)(connect(mapState)(FooterBlockForm)));